import { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";

const AdminContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AdminProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem("admin_token") || "");
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const api = useMemo(() => {
    const instance = axios.create({ baseURL: API });
    instance.interceptors.request.use(config => {
      const t = localStorage.getItem("admin_token");
      if (t) config.headers.Authorization = `Bearer ${t}`;
      return config;
    });
    return instance;
  }, []);

  useEffect(() => {
    if (token) {
      api.get("/admin/me").then(res => {
        setAdmin(res.data);
        setLoading(false);
      }).catch(() => {
        setToken("");
        localStorage.removeItem("admin_token");
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [token, api]);

  const login = useCallback(async (email, password) => {
    const res = await axios.post(`${API}/admin/login`, { email, password });
    setToken(res.data.token);
    localStorage.setItem("admin_token", res.data.token);
    setAdmin({ email: res.data.email });
    return res.data;
  }, []);

  const logout = useCallback(() => {
    setToken("");
    setAdmin(null);
    localStorage.removeItem("admin_token");
  }, []);

  return (
    <AdminContext.Provider value={{ token, admin, loading, login, logout, api }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  return useContext(AdminContext);
}
